export class SearchService {
	static getTotalRows(data) {
		return data && data.length && data[0].totalRows
	}
}
